<template>
  <v-app>
    <v-navigation-drawer
      v-if="showLayout"
      permanent
      v-model="drawer"
      app
      class="ob-app-drawer">
      <v-layout class="ob-main-title pa-2" column>
        <v-flex d-flex align-center>
          <h1 class="headline white--text">
            {{title}}
            <img src="/img/logo_tuds_analytics_284w.png" alt="TUD's Analytics logo" width="100%">
          </h1>
        </v-flex>
      </v-layout>
      <v-flex d-flex class="pl-2 mt-2">
        <v-chip color="secondary" text-color="white" class="ob-no-grow-or-shrink" close @input="logout">
          <v-avatar>
            <img :src="avatar">
          </v-avatar>
          <template>
            <span class="text-no-wrap text-truncate" style="max-width: 150px">
            {{username || 'Anonim'}}
            </span>
          </template>
        </v-chip>
        <v-spacer></v-spacer>
        <v-switch
          v-if="user && user.admin"
          :dark="true"
          :height="'48px'"
          hide-details
          class="ma-0 pa-0"
          label="client"
          v-model="seeAsClient">
        </v-switch>
        <v-spacer></v-spacer>
        <v-btn icon flat class="ob-no-grow-or-shrink" @click.stop="_cbOpenSettings">
          <v-icon color="secondary lighten-2">mdi-tune</v-icon>
        </v-btn>
      </v-flex>
      <v-list class="transparent" dark dense>
        <v-list-group v-for="group in whichGroups" :key="group.label" v-model="group.active">
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title class="accent--text text-uppercase">{{ translateUI(group.label, lang) }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- <template v-if="group.label === 'SideBar_5' && user && user.admin">
            <v-list-tile key="recompute-all">
              <v-list-tile-action>
                <v-icon small>mdi-circle-outline</v-icon>
              </v-list-tile-action>
              <v-list-tile-content style="flex-direction: row; align-items: center; justify-content: space-between">
                Tot
                <v-spacer></v-spacer>
                <v-btn icon small class="ma-0" color="error" :disabled="!recomputeAll" @click="_cbRecomputeAll(null)">
                  <v-icon small>mdi-function-variant</v-icon>
                </v-btn>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-switch v-model="recomputeAll" :color="recomputeAll ? 'error' : 'grey'" style="transform: scale(.75)"></v-switch>
              </v-list-tile-action>
            </v-list-tile>
          </template> -->

          <template v-if="!user.tip_apl || !user.tip_apl.length || user.tip_apl.includes(item.tip_apl)">
            <v-list-tile
              v-for="(item, i) in group.items"
              :key="`${group.label}-${i}`"
              :to="item.path"
              exact
              active-class="accent--text text--lighten-1">
              <v-list-tile-action>
                <v-icon small>mdi-circle-outline</v-icon>
              </v-list-tile-action>
              <v-list-tile-content style="flex-direction: row; align-items: center; justify-content: space-between">
                {{ translateUI(item.title, lang) }}
                <v-spacer></v-spacer>
                <v-btn icon small class="ma-0" color="error" :disabled="!recompute[item.recompute]" @click.stop.prevent="_cbRecomputeAll(item.recompute)" v-if="item.action">
                  <v-icon small>mdi-function-variant</v-icon>
                </v-btn>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </v-list-tile-content>
              <v-list-tile-action v-if="item.action" @click.stop.prevent>
                <v-switch v-model="recompute[item.recompute]" :color="recompute[item.recompute] ? 'error' : 'grey'" style="transform: scale(.75)"></v-switch>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <v-slide-x-transition hide-on-leave mode="out-in" tag="div">
        <router-view/>
      </v-slide-x-transition>

      <v-dialog v-model="settingsDialog" width="500" persistent>
        <v-card>
          <v-card-title class="headline primary white--text">
            Setari cont
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="oldPass"
                :type="visibleOldPass ? 'text' : 'password'"
                :prepend-icon="visibleOldPass ? 'mdi-eye-off' : 'mdi-eye'"
                @click:prepend="_cbToggleVisible('visibleOldPass')"
                label="Parola curenta"
                placeholder="parola curenta"
                hint="Parola pe cu care v-ati autentificat in sesiunea curenta."
                :rules="getRules('oldPass')"
                class="mb-4">
              </v-text-field>
              <v-text-field
                v-model="newPass"
                :type="visibleNewPass ? 'text' : 'password'"
                :prepend-icon="visibleNewPass ? 'mdi-eye-off' : 'mdi-eye'"
                append-icon="mdi-lock-reset"
                @click:append="_cbGeneratePassword"
                @click:prepend="_cbToggleVisible('visibleNewPass')"
                label="Parola noua"
                placeholder="parola noua"
                hint="Parola noua trebuie sa fie de minim 8 caractere lungime si sa contina: litere mici, litere mari, cifre si caractere speciale (!, @, #, $, %, ^, &)!"
                :rules="getRules('newPass')"
                loading
                counter="16"
                class="mb-4">
                <template v-slot:progress>
                <v-progress-linear
                  :value="newPassLength2Percentage"
                  :color="newPassColor"
                  height="2"
                ></v-progress-linear>
              </template>
              </v-text-field>
              <v-text-field
                v-model="rNewPass"
                :type="visibleNewRepeatPass ? 'text' : 'password'"
                :prepend-icon="visibleNewRepeatPass ? 'mdi-eye-off' : 'mdi-eye'"
                @click:prepend="_cbToggleVisible('visibleNewRepeatPass')"
                label="Repetare parola noua"
                placeholder="repetare parola noua"
                hint="Din motive de securitate va rugam sa repetati parola noua."
                :rules="getRules('rNewPass')">
              </v-text-field>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="_cbCloseSettingsDialog(0)">
              Anuleaza
            </v-btn>
            <v-btn color="primary" flat @click="_cbCloseSettingsDialog(1)" :disabled="loadingPassChange">
              Salveaza
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" bottom :timeout="3000" :color="snackColor">
        {{ snackMessage }}
        <v-btn color="white" flat @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>

      <v-bottom-sheet v-model="log.open" hide-overlay v-if="user && (user.admin || user.limitedadmin)">
        <v-card tile>
          <v-card-title class="py-0">
            <v-subheader>
              Activitate
            </v-subheader>
            <v-spacer></v-spacer>
            <v-menu offset-y>
              <v-btn slot="activator" :color="logfilter === 'toate' ? 'grey' : logfilter" flat>
                <v-icon left>mdi-filter-variant</v-icon>
                {{ logfilter }}
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="item in ['success', 'info', 'error', 'toate']"
                  :key="item"
                  @click="changeLogFilter(item)">
                  <v-list-tile-action>
                    <v-icon small v-if="item === 'error'" color="error">mdi-alert-decagram</v-icon>
                    <v-icon small v-if="item === 'info'" color="info">mdi-alert-circle</v-icon>
                    <v-icon small v-if="item === 'success'" color="success">mdi-check-circle</v-icon>
                    <v-icon small v-if="item === 'toate'" color="grey">mdi-filter-remove</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>{{ item }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="closeSheet">
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="overflow-y: auto" class="py-0">
            <v-list dense>
              <v-list-tile
                v-for="message in filteredMessages"
                :key="message._id">
                <v-list-tile-action>
                  <v-icon v-if="message.type === 'error'" color="error">mdi-alert-decagram</v-icon>
                  <v-icon v-if="message.type === 'info'" color="info">mdi-alert-circle</v-icon>
                  <v-icon v-if="message.type === 'success'" color="success">mdi-check-circle</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-html="message.text"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="message.timestamp"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn small flat icon @click="deleteMessage(message._id)">
                    <v-icon small color="error">mdi-delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-pagination
              circle
              v-model="logPage"
              :length="log.pages"
              :total-visible="5"
               class="ob-log">
            </v-pagination>
            <v-spacer></v-spacer>
            <v-switch
              v-if="this.user"
              color="primary"
              label="Log-ul ramane inchis"
              v-model="logclosed"
              hide-details>
            </v-switch>
            <v-btn flat @click="clearMessages" :disabled="!messages.length" v-if="this.user">
              Sterge mesajele: {{ logfilter }}
              <v-icon right color="error">mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-bottom-sheet>
    </v-content>
    <v-footer fixed app>
      <v-spacer></v-spacer>
      <span>&copy; {{ (new Date()).getFullYear() }} - Verde Smart Data</span>
      <template v-if="user && (user.admin || user.limitedadmin)">
        <v-badge overlap class="ob-messages-badge" color="accent">
        <span slot="badge">{{messages.length > 9 ? '9+' : messages.length}}</span>
        <v-btn small flat icon @click="openMessages">
          <v-icon color="info">mdi-bell</v-icon>
        </v-btn>
        </v-badge>
      </template>
      <v-spacer></v-spacer>
      <template v-if="serverStats && user && (user.admin || user.limitedadmin)">
        <span class="caption">
          cpu
        </span>
        <v-icon
        small
        :color="getColor(serverStats.cpuPercentage)"
        v-html="getIcon(serverStats.cpuPercentage)">
        </v-icon>
        <span class="caption">
          {{ serverStats.cpuPercentage }}%
        </span>
        <v-spacer></v-spacer>

        <span class="caption">
          ram
        </span>
        <v-icon
        small
        :color="getColor((serverStats.memPercentage.usedMemMb * 100 / serverStats.memPercentage.totalMemMb))"
        v-html="getIcon((serverStats.memPercentage.usedMemMb * 100 / serverStats.memPercentage.totalMemMb ))">
        </v-icon>
        <span class="caption">
          {{ (serverStats.memPercentage.usedMemMb * 100 / serverStats.memPercentage.totalMemMb).toFixed(2) }}%
        </span>
        <v-spacer></v-spacer>

        <span class="caption">
          ssd
        </span>
        <v-icon
        small
        :color="getColor(serverStats.drvPercentage.usedPercentage)"
        v-html="getIcon(serverStats.drvPercentage.usedPercentage)">
        </v-icon>
        <span class="caption">
          {{ serverStats.drvPercentage.usedPercentage }}%
        </span>
        <v-spacer></v-spacer>

        <span class="caption">
          storage (db)
        </span>
        <v-icon
        small
        :color="getColor(serverStats.dbPercentage.usedPercentage)"
        v-html="getIcon(serverStats.dbPercentage.usedPercentage)">
        </v-icon>
        <span class="caption">
          {{ serverStats.dbPercentage.usedPercentage }}%
        </span>
        <v-spacer></v-spacer>
      </template>
      <v-btn icon small @click="getServerStats" v-if="user && (user.admin || user.limitedadmin)">
        <v-icon color="info" small>mdi-information-variant</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-menu offset-y v-if="user && (user.admin || user.limitedadmin)" v-model="poolMenu">
        <template v-slot:activator="{ on }">
          <v-btn icon small @click="getPoolData" v-on="on">
            <v-icon color="info" small>mdi-cogs</v-icon>
          </v-btn>
        </template>
        <v-card width="500">
          <v-card-title>Pool threads</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap v-if="poolData && poolData.length">
              <v-flex v-for="pool in poolData" :key="pool.name" xs12>
                <v-card class="ma-2">
                  <v-card-title>{{ pool.name }}</v-card-title>
                  <v-card-text>
                    <v-progress-linear :value="pool.counter ? pool.counter.completed * 100 / pool.counter.sent : 0" height="1.5em">
                      <div class="d-flex">
                        <v-spacer></v-spacer>
                        taskuri: {{ pool.counter ? `trimise ${pool.counter.sent} / incheiate ${pool.counter.completed}` : '-' }}
                        <v-spacer></v-spacer>
                        rata: {{ pool.rate }}/task
                        <v-spacer></v-spacer>
                      </div>
                    </v-progress-linear>
                    <div>Inceput: {{ pool.started ? `acum ${pool.started}` : '-' }}</div>
                    <div>Ramas: {{ pool.remaining || '-' }}</div>
                    <div>Simultan: {{ pool.cores }} taskuri</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="pool.started"
                      flat
                      color="error"
                      @click="destoryPool(pool.name)">
                      Distruge
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
            <div v-else class="pa-3">Nu exista niciun pool activ</div>
          </v-card-text>
        </v-card>
      </v-menu>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on">
            <template v-if="lang === 'en'">
              <flag iso="us" :squared="false" />
              /
              <flag iso="gb" :squared="false" class="mr-2" />
            </template>
            <template v-else>
              <flag :iso="lang" :squared="false" class="mr-2" />
            </template>
            {{ lang }}
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="l in langs"
            :key="l"
            @click="setLang(l)">
            <v-list-tile-title class="text-uppercase">{{ l }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
    </v-footer>
  </v-app>
</template>

<script>
import rules from '@/helpers/validation';
import translate from '@/mixins/Translate';
import pwd from 'generate-password';
import _debounce from 'lodash.debounce';

export default {
  name: 'App',
  mixins: [translate],
  data () {
    return {
      poolInterval: null,
      poolMenu: false,
      recomputeAll: false,
      recompute: {
        Judet: false,
        Municipiu: false,
        Oras: false,
        Comuna: false,
        [['Judet', 'Municipiu', 'Oras', 'Comuna']]: false
      },
      logfilter: 'toate',
      drawer: true,
      seeAsClient: false,
      groups: {
        admin: [
          {
            label: 'SideBar_5',
            active: true,
            items: [
              {
                title: 'SideBar_0',
                path: '/dashboard/all',
                action: true,
                recompute: ['Judet', 'Municipiu', 'Oras', 'Comuna']
              },
              {
                title: 'SideBar_2',
                path: '/dashboard/judete',
                action: true,
                recompute: 'Judet'
              },
              {
                title: 'SideBar_3',
                path: '/dashboard/municipii',
                action: true,
                recompute: 'Municipiu'
              },
              {
                title: 'SideBar_4',
                path: '/dashboard/orase',
                action: true,
                recompute: 'Oras'
              },
              {
                title: 'SideBar_4.1',
                path: '/dashboard/comune',
                action: true,
                recompute: 'Comuna'
              },
              {
                title: 'SideBar_4.2',
                path: '/dashboard/download',
                action: false
              }
            ]
          },
          {
            label: 'SideBar_6',
            active: true,
            items: [
              {
                title: 'SideBar_7',
                path: '/dashboard/cifuri'
              },
              {
                title: 'SideBar_8',
                path: '/dashboard/clasificatie-bugetara'
              },
              {
                title: 'SideBar_9',
                path: '/dashboard/rapoarte-indicatori'
              },
              {
                title: 'SideBar_10',
                path: '/dashboard/sistem-de-verificare'
              },
              {
                title: 'SideBar_11',
                path: '/dashboard/date-financiare'
              },
              {
                title: 'SideBar_12',
                path: '/dashboard/dictionar'
              },
              {
                title: 'SideBar_13',
                path: '/dashboard/utilizatori'
              },
              {
                title: 'SideBar_14',
                path: '/dashboard/liste'
              },
              {
                title: 'SideBar_15',
                path: '/dashboard/rapoarte'
              },
              {
                title: 'SideBar_16',
                path: '/dashboard/access'
              },
              {
                title: 'SideBar_Maps',
                path: '/dashboard/maps'
              },
              {
                title: 'SideBar_ClasificatieCheck',
                path: '/dashboard/clasificatiecheck'
              },
              {
                title: 'SideBar_Automation',
                path: '/dashboard/automation'
              },
              {
                title: 'SideBar_MFData',
                path: '/dashboard/mfdata'
              },
              {
                title: 'SideBar_Storage',
                path: '/dashboard/storage'
              }
            ]
          },
          {
            label: 'SideBar_Admin_Rapoarte',
            active: true,
            items: [
              {
                title: 'SideBar_Admin_Rapoarte_Judete',
                path: '/dashboard/rapoarte-judete'
              },
              {
                title: 'SideBar_Admin_Rapoarte_Municipii',
                path: '/dashboard/rapoarte-municipii'
              },
              {
                title: 'SideBar_Admin_Rapoarte_Orase',
                path: '/dashboard/rapoarte-orase'
              },
              {
                title: 'SideBar_Admin_Rapoarte_Comune',
                path: '/dashboard/rapoarte-comune'
              }
            ]
          },
          {
            label: 'SideBar_Admin_RapoarteAgregate',
            active: true,
            items: [
              {
                title: 'SideBar_Admin_Rapoarte_Agregate',
                path: '/dashboard/rapoarte-agregate'
              }
            ]
          },
          {
            label: 'SideBar_Admin_RapoarteInteractive',
            active: true,
            items: [
              {
                title: 'SideBar_Admin_Rapoarte_Interactive',
                path: '/dashboard/rapoarte-interactive'
              }
            ]
          },
          {
            label: 'SideBar_Admin_Harti',
            active: true,
            items: [
              {
                title: 'SideBar_Admin_Harti',
                path: '/dashboard/harti'
              }
            ]
          }
        ],
        client: [
          {
            label: 'SideBar_1',
            active: true,
            items: [
              {
                title: 'SideBar_2',
                path: '/dashboard-client/judete-client',
                tip_apl: 'Judet'
              },
              {
                title: 'SideBar_3',
                path: '/dashboard-client/municipii-client',
                tip_apl: 'Municipiu'
              },
              {
                title: 'SideBar_4',
                path: '/dashboard-client/orase-client',
                tip_apl: 'Oras'
              },
              {
                title: 'SideBar_4.1',
                path: '/dashboard-client/comune-client',
                tip_apl: 'Comuna'
              }
            ]
          }
          // {
          //   label: 'SideBar_2.1_Alte_Optiuni',
          //   active: true,
          //   items: [
          //     {
          //       title: 'SideBar_2.2_Rapoarte_agregate',
          //       path: '/dashboard-client/rapoarte-agregate'
          //     },
          //     {
          //       title: 'SideBar_2.3_Rapoarte_interactive',
          //       path: '/dashboard-client/rapoarte-interactive'
          //     },
          //     {
          //       title: 'SideBar_2.3_Harti',
          //       path: '/dashboard-client/harti'
          //     }
          //   ]
          // }
        ],
        limitedadmin: [
          {
            label: 'SideBar_6',
            active: true,
            items: [
              {
                title: 'SideBar_13',
                path: '/dashboard/utilizatori'
              },
              {
                title: 'SideBar_16',
                path: '/dashboard/access'
              }
            ]
          }
        ]
      },
      title: null,
      settingsDialog: false,
      visibleOldPass: false,
      visibleNewPass: false,
      visibleNewRepeatPass: false,
      oldPass: '',
      newPass: '',
      rNewPass: '',
      valid: true,
      snackbar: false,
      snackMessage: '',
      snackColor: 'success',
      loadingPassChange: false
    }
  },
  watch: {
    seeAsClient (value) {
      if (!value) this.$router.push({ name: 'users' })
      else this.$router.push({ name: 'municipii-client' })
    },
    snackbar (value) {
      if (!value) {
        this.snackColor = null
        this.snackMessage = null
      }
    },
    oldPass () {
      this.$refs.form.validate()
    },
    newPass () {
      this.$refs.form.validate()
    },
    rNewPass () {
      this.$refs.form.validate()
    },
    '$route.path' () {
      if (this.settingsDialog) {
        this._cbCloseSettingsDialog(0)
      }
    },
    poolMenu (value) {
      if (value) {
        this.poolInterval = setInterval(() => {
          this.$store.dispatch('getPoolData')
        }, 2000)
      } else {
        clearInterval(this.poolInterval)
      }
    }
  },
  computed: {
    logclosed: {
      get () {
        return !!this.user.logclosed
      },
      set (value) {
        this.$store.dispatch('toggleLog', value)
      }
    },
    log () {
      return this.$store.getters.log
    },
    messages () {
      return this.log.items
    },
    logPage: {
      get () {
        return this.log.page
      },
      set (value) {
        this.$store.dispatch('setLogPage', value)
      }
    },
    showLayout () {
      switch (this.$route.path) {
        case '/': return false
        default: return true
      }
    },
    user () {
      return this.$store.getters.user
    },
    username () {
      return this.user ? this.user.username : ''
    },
    avatar () {
      return this.user ? this.user.avatar.replace('d=mp', 'd=https%3A%2F%2Fanalytics.verdedata.ro%2Fimg%2Ftud_group_sq.png') : 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAALCAAgACABAREA/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/9oACAEBAAA/AP7+K8y8c/FzwV8PpYrTXb+aXUpo1mTStMtjfagLdiwWeaMPFDawuVIia6nhM21jCsgViHeBfi14L+IUk1toN/NHqMEZnl0rUrc2OoC3BVTcRRF5IbqFWZRJJazzCEsnnCPeufS6D/n6d/0r8nviVNqM/wAQfGkmqmQ3v/CS6rHIJCcpDBcvDZRpn/ljHYJarbgfL5HllflIqX4XTajB8RvBL6WZBeHxJpsQEZYb7aecQ6ij7f8Ali+nPdCcH5fJDs3C5H6uVXurq3sbW4vbuaO3tbSCW5ubiZgkUFvAjSzTSueEjjjVndj0VSa/Pb4lePPhN4+8RT38vh/xXp8qRi3HijRJtJW41dIP3cEl7oGpBIpIljG22uWvbfURB5cc6CNEijm+Fvj34S+BPEcV3/YfiieSZDar4s1yfS5ptKS4zHM0GhaWpitbZ0IW6u4ru+1AQeYioIWkjb9BoJ4bmGG5t5Y57e4ijngnidZIpoZUEkUsUikq8ciMro6kqykEEg14d+0bqs2m/C3V4oGKNq19pOkSMCQ32e6vFmukBHaWC1khcdGjkdTkHFfm7QPbrX6S/s6avcar8LtHjuWZ30i71PRkdySxtrK6L2i5P8MVtcRQp6RxoBwK/9k='
    },
    whichGroups () {
      if (this.user) {
        if (this.user.admin && !this.seeAsClient) return this.groups['admin']
        if (this.user.limitedadmin) return [ ...this.groups['client'], ...this.groups['limitedadmin'] ]
        return this.groups['client']
      }
      return []
    },
    serverStats () {
      return this.$store.getters.serverStats
    },
    langs () {
      return this.$store.getters['dictionar/languages']
    },
    lang () {
      return this.$store.getters['dictionar/lang']
    },
    newPassLength2Percentage () {
      return Math.min(Math.floor(this.newPass.length * 100 / 16), 100)
    },
    newPassColor () {
      return ['error', 'warning', 'success'][Math.floor(this.newPassLength2Percentage / 40)]
    },
    filteredMessages () {
      return this.messages.filter(message => this.logfilter === 'toate' || message.type === this.logfilter)
    },
    poolData () {
      return this.$store.getters['poolData']
    }
  },
  methods: {
    _cbRecomputeAll (tipApl = null) {
      this.$dialog
        .confirm({
          title: `Atentie! Doresti sa recalculezi ${!Array.isArray(tipApl) ? 'toate CIF-urile de tip ' + tipApl.toUpperCase() : 'TOT'}!`,
          body: 'Aceasta operatiune dureaza! Doresti sa purcezi?'
        }, {
          okText: 'DA',
          cancelText: 'Aaaa... mai bine nu.',
          animation: 'zoom'
        })
        .then(dialog => {
          if (tipApl) this.recompute[tipApl] = false
          else this.recomputeAll = false
          this.$store.dispatch('recomputeAll', tipApl)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getIcon (value) {
      if (isNaN(value)) return 'mdi-battery-off-outline'
      if (value > 95) return 'mdi-battery-charging-100'
      if (value > 85) return 'mdi-battery-charging-90'
      if (value > 75) return 'mdi-battery-charging-80'
      if (value > 65) return 'mdi-battery-charging-70'
      if (value > 55) return 'mdi-battery-charging-60'
      if (value > 45) return 'mdi-battery-charging-50'
      if (value > 35) return 'mdi-battery-charging-40'
      if (value > 25) return 'mdi-battery-charging-30'
      if (value > 15) return 'mdi-battery-charging-20'
      if (value > 5) return 'mdi-battery-charging-10'
      return 'mdi-battery-charging-outline'
    },
    getColor (value) {
      if (isNaN(value)) return 'error'
      if (value < 50) return 'success'
      if (value < 75) return 'info'
      if (value < 90) return 'warning'
      return 'error'
    },
    getServerStats () {
      this.$store.dispatch('getServerStats')
    },
    getPoolData () {
      this.poolMenu = true
    },
    destoryPool (name) {
      this.$store.dispatch('destoryPool', name)
    },
    changeLogFilter (type) {
      this.logfilter = type
      this.$store.dispatch('changeLogFilter', type)
    },
    deleteMessage (id) {
      this.$store.dispatch('deleteMessage', id)
    },
    clearMessages () {
      this.$store.dispatch('clearMessages', this.logfilter)
    },
    closeSheet () {
      this.$store.commit('closeMessages')
    },
    openMessages () {
      this.$store.commit('openMessages')
    },
    logout () {
      this.$router.push({ name: 'home' })
      this.$store.dispatch('logout')
    },

    setLang (lang) {
      this.$store.commit('dictionar/setLang', lang)
    },

    _cbOpenSettings () {
      this.settingsDialog = true
    },
    _cbCloseSettingsDialog: _debounce(function (mode) {
      if (mode) {
        const valid = this.$refs.form.validate()
        if (valid) {
          this.loadingPassChange = true
          this.$store.state.services.users.patch(this.user._id, { password: this.newPass, oldPass: this.oldPass })
            .then(res => {
              this.snackColor = 'success'
              this.snackMessage = this.translateUI('PassChangeOK', this.lang) || 'Parola schimbata cu succes!'
            })
            .catch(err => {
              // PassChangeFail
              // PassChangeFailNoReason
              this.snackColor = 'error'
              if (err.message && err.message === 'Parola curenta nu este corecta!') {
                this.snackMessage = this.translateUI('PassChangeFail', this.lang) || 'Eroare la schimbarea parolei!'
              } else {
                this.snackMessage = this.translateUI('PassChangeFail', this.lang) || 'Eroare la schimbarea parolei!'
              }
            })
            .finally(() => {
              this.snackbar = true
              this.oldPass = ''
              this.newPass = ''
              this.rNewPass = ''
              this.settingsDialog = false
              this.loadingPassChange = false
            })
        }
      } else {
        this.oldPass = ''
        this.newPass = ''
        this.rNewPass = ''
        this.settingsDialog = false
      }
    }, 500),
    _cbToggleVisible (field) {
      this[field] = !this[field]
    },
    _cbGeneratePassword () {
      const pass = pwd.generate({
        length: 16,
        numbers: true,
        symbols: true,
        uppercase: true,
        exclude: '*()+_-=}{[]|:;"/?.><,`~',
        strict: true
      })

      this.newPass = pass
      this.rNewPass = pass
    },
    getRules (field) {
      switch (field) {
        case 'oldPass': return [rules.required]
        case 'newPass': return [
          rules.required,
          rules.password,
          () => this.newPass !== this.rNewPass ? 'Parola noua nu coincide cu verificarea parolei!' : true,
          () => this.oldPass === this.newPass ? 'Parola noua nu poate coincide cu parola veche!' : true
        ]
        case 'rNewPass': return [
          rules.required,
          rules.password,
          () => this.newPass !== this.rNewPass ? 'Verificarea parolei nu coincide cu parola noua!' : true,
          () => this.oldPass === this.newPass ? 'Parola noua nu poate coincide cu parola veche!' : true
        ]
      }
    }
  },
  created () {
    this.$store.dispatch('dictionar/fetchLanguagesAndUI')
    // this.$store.dispatch('dictionar/getLanguages')
    // this.$store.dispatch('dictionar/fetchUI')

    // console.log('app ready')
  }
}
</script>

<style lang="stylus">
  .interactive-wizard {
    .v-list__tile {
      padding-left: 0 !important
    }
  }

  .ob-ellipsis {
    display: inline-block
    max-width: 100px
    white-space: nowrap !important
    overflow: hidden
    text-overflow: ellipsis
  }

  .MathJax_Display, .MathJax.MathJax_FullWidth {
    // text-align: left !important
  }

  .ob-list-tight {
    &.v-list--two-line.v-list--dense .v-list__tile {
      height: 40px
    }
  }

  .ob-log {
    .v-pagination__item {
      min-width: 20px !important
      height: 20px !important
      font-size: 10px !important
    }

    .v-pagination__navigation {
      width: 20px !important
      height: 20px !important
      .v-icon {
        font-size: 14px !important
      }
    }
  }

  .ob-messages-badge {
    .v-badge__badge {
      font-size: 10px !important
      width: 18px
      height: 18px
      top: 2px
      right: 2px
    }
  }

  .ob-ellipsis {
    display: inline-block
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  }

  .ob-section-toolbar {
    .v-input__slot {
      background-color: transparent !important
    }
  }

  .ob-section-tabs {
    .v-tabs__icon {
      // color: white
    }

    .v-tabs__item--active {
      color: #03b795;
    }
  }

  .ob-section-title-and-tabs {
    background-color: rgba(112, 146, 190, 0)
    // border-left: 4px solid #3e7fc2
  }

  // table.v-table tbody td:not(.v-datatable__expand-col), table.v-table tbody th {
  //   height: 24px !important
  // }

  .ob-table {
    &.ob-table-dark-header {
      table {
        background-color: transparent
      }

      tbody {
        background-color: white
        td {
          white-space: nowrap
          padding: 0 4px !important
          height: auto !important
          &:not(:first-child) {
            // padding: 0 4px !important
          }
        }
      }

      thead {
        th {
          // background-color: rgba(192, 207, 226, 0)
          background-color: rgba(255, 255, 255, .1)
          // background-color: transparent
          font-size: 14px
          padding: 0 4px !important

          &:not(:first-child) {
            // padding: 0 4px !important
          }

          &:first-child {
            .v-icon.mdi {
              color: rgb(96, 125, 139)
            }
          }
        }
      }
    }

    &.ob-check-adjust {
      .v-input--checkbox {
        .v-input__slot {
          margin-bottom: 0 !important
        }
      }
    }
  }

  .ob-flex {
    display: flex
  }

  .ob-flex-1-1-100 {
    flex: 1 1 auto
  }

  .ob-justify-space-between {
    justify-content: stretch
  }

  .ob-align-bottom {
    align-items: flex-end
  }

  .ob-align-center {
    align-items: center
  }

  .ob-menu-tab-item {
    display: flex
    align-items: center
  }

  .ob-no-wrap {
    white-space: nowrap
  }

  .ob-speed-dial {
    bottom: 20px !important
    transform: none !important
  }

  .ob-compute-fab {
    position: fixed
    bottom: 40px !important
    right: 20px
    transform: none !important
  }

  .application--wrap {
    background-color: #eee
  }

  .ob-main-title {
    // background-image: url(https://cdn.oboi7.com/static/images/m/2b/04/2b0419dac75f7723e9ba28034a56438c041ddb8e.jpg)
    // background-size: cover
    background-color: white;
    height: 152px;
  }

  .ob-no-grow-or-shrink {
    flex: 0 0 auto !important
  }

  .theme--light.v-tabs__bar {
    background-color: transparent
  }

  .ob-app-drawer {
    background-color: rgba(62, 127, 194, 1) !important
  }

  .ob-new-account {
    background-image: url('/img/user-nou-card.jpg')
  }

  .ob-no-bg-color {
    background-color: transparent !important
  }

  .ob-hero {
    background-image: linear-gradient(135deg, rgba(255,255,255,0.7) 0%, rgba(0,96,100,0.5) 100%), url(/img/hero.jpg)
    background-size: 100%, cover
  }

  .ob-no-grow {
    flex-grow: 0 !important
  }

  .ob-icon-size {
    font-size: 70px
  }

  .ob-container {
    // background-image: url('/img/bg.jpg')
    background-size: cover
  }

  .ob-rounded-corners {
    border-radius: 2em
  }

  .ob-login {
    // background-image: linear-gradient(rgba(255, 255, 255, 0.5), rgba(0, 96, 100, 0.7)), url('/img/login-banner.jpg')
    background-image: url('/img/user-nou-card.jpg')
    background-size: cover

    .ob-textfield {
      background-color: rgba(0, 96, 100, 0.2)

      input {
        text-align: center
        color: #006064
      }

      .v-input__slot {
        background-color: transparent !important
      }
    }

    .ob-login-links {
      text-decoration: none
    }
  }

  .ob-card-bg {
    // background-color: rgba(0, 96, 100, 0.2)
    // background-color: #cadedf
  }

  .ob-client-pagination {
    padding-left: 14px
    margin-top: 4px

    .v-pagination__item {
      min-width: 20px !important
      height: 20px !important
      font-size: 10px !important
    }

    .v-pagination__navigation {
      width: 20px !important
      height: 20px !important
      .v-icon {
        font-size: 14px !important
      }
    }
  }

  .ob-client-search {
    padding-left: 24px !important
    margin-right: 24px !important
  }

  .ob-section-title {
    padding-left: 23px
  }

  .ob-section-tabs {
    padding-left: 2px
  }

  .ob-no-records {
    margin: 4px 23px !important
  }

  .ob-line-through {
    text-decoration: line-through
  }

  .ob-rotate {
    animation: rotation .5s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }

  .ob-short-div {
    max-height: 60px;
    overflow-y: auto;
  }

  .ob-autocomplete-in-form {
    .v-input__slot {
      padding-left: 0 !important;
    }
  }

  .reports-list-client {
    .v-list__group__header__prepend-icon i {
      font-size: 16px;
    }

    .v-list__group__header__append-icon i {
      font-size: 16px;
    }

    .v-list__group__items {
      .v-list__tile {
        height: 40px !important;
        padding-left: 32px !important;
      }
    }

    .download-reports {
      .v-list__tile {
        height: 40px !important;
      }
    }
  }

  .admin-table-data {
    max-height: 40px !important;
    overflow-y: auto;
  }
</style>
